// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabsWrapper {
  position: relative;
}
.TabsWrapper .select-group {
  width: 317px;
}
.TabsWrapper-content {
  margin-top: 7px;
  background-color: var(--base_color2);
  width: 432px;
  z-index: 100;
  border-radius: 4px;
  position: absolute;
  left: -114px;
  padding: 30px;
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  box-shadow: 8px 10px 12px rgba(0, 0, 0, 0.15);
  min-height: 301px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 17.57px;
  gap: 25px;
}
.TabsWrapper-content-tabs {
  display: flex;
  gap: 35px;
}
.TabsWrapper-content-tabs-tab {
  padding: 0;
  font-weight: 400;
  color: var(--color_neutral_500);
}
.TabsWrapper-content-tabs-tab-active {
  color: var(--color_primary_500);
  position: relative;
  padding: 0;
  font-weight: bold;
}
.TabsWrapper-content-tabs-tab-active::after {
  position: absolute;
  content: "";
  left: 1px;
  top: 19px;
  transition: width 200ms;
  transition-delay: 200ms;
  width: 32px;
  border: 1px solid var(--color_primary_500);
}`, "",{"version":3,"sources":["webpack://./src/components/TabsToggle/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,eAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,6CAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,SAAA;AAAJ;AAEI;EACE,aAAA;EACA,SAAA;AAAN;AAEM;EACE,UAAA;EACA,gBAAA;EACA,+BAAA;AAAR;AAEQ;EACE,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AAAV;AAEU;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,0CAAA;AAAZ","sourcesContent":[".TabsWrapper {\n  position: relative;\n\n  .select-group {\n    width: 317px;\n  }\n\n  &-content {\n    margin-top: 7px;\n    background-color: var(--base_color2);\n    width: 432px;\n    z-index: 100;\n    border-radius: 4px;\n    position: absolute;\n    left: -114px;\n    padding: 30px;\n    box-sizing: border-box;\n    border: 1px solid #e5e5e5;\n    box-shadow: 8px 10px 12px rgba(0, 0, 0, 0.15);\n    min-height: 301px;\n    display: flex;\n    flex-direction: column;\n    font-size: 14px;\n    line-height: 17.57px;\n    gap: 25px;\n\n    &-tabs {\n      display: flex;\n      gap: 35px;\n\n      &-tab {\n        padding: 0;\n        font-weight: 400;\n        color: var(--color_neutral_500);\n\n        &-active {\n          color: var(--color_primary_500);\n          position: relative;\n          padding: 0;\n          font-weight: bold;\n\n          &::after {\n            position: absolute;\n            content: '';\n            left: 1px;\n            top: 19px;\n            transition: width 200ms;\n            transition-delay: 200ms;\n            width: 32px;\n            border: 1px solid var(--color_primary_500);\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
